import React, { useState, useReducer } from "react"
import * as styles from "./Styles/CrowdLampSwitch.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import Icon from "../Utils/Icon"
import TrafficLightWidget from "../Common/TrafficLightWidget"
import { SHELTER_LAMP_MAP } from "../Utils/lamp"

const LampSwitch = (props) => {
  const path = {
    green: `${props.params.path}?color=green`,
    yellow: `${props.params.path}?color=yellow`,
    red: `${props.params.path}?color=red`,
    turnedOff: `${props.params.path}?color=turnedOff`,
  }

  const activeColor = props.params.active ? props.params.active.color : null

  return (
    <React.Fragment>
      <div className={cn("l-flex", "controls")}>
        <div className={cn("l-flex", "buttons")}>
          {Object.keys(SHELTER_LAMP_MAP)
            .slice(0, 3)
            .map((key, i) => (
              <a key={i} className={styles.link} href={path[key]}>
                <div
                  className={cn([
                    "l-centering",
                    "lampButton",
                    `lampButton--${key}`,
                    { active: activeColor == null || activeColor == key },
                  ])}
                >
                  {SHELTER_LAMP_MAP[key].message}
                </div>
              </a>
            ))}
        </div>
        <div className={cn("l-centering", "trafficLightWrapper")}>
          <TrafficLightWidget
            width={160}
            currentColor={activeColor || "turnedOff"}
          />
          {activeColor != null && (
            <div className={styles.activeLamp}>
              <div>
                <span>次の操作まで表示されます</span>
              </div>
              <div>
                <a href={path.turnedOff}>取り消す</a>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.annotation}>
        <div className={styles.annotationHeader}>
          <Icon className={styles.infoIcon} type="feather" name="info" />
          <span>混雑ランプとは</span>
        </div>
        <div>
          施設の現在の混雑状況をお知らせする機能です。ボタンを押してから、取り消すか次に更新するまで有効となります。
        </div>
      </div>
    </React.Fragment>
  )
}

const CrowdLampSwitch = (props) => {
  return (
    <div className="l-section-background--admin">
      <div className={styles.section}>
        <div className={styles.left}>混雑ランプ</div>
        <div className={styles.right}>
          <LampSwitch {...props} />
        </div>
      </div>
    </div>
  )
}

export default CrowdLampSwitch
